export default "__VITE_ASSET__AkOMbbQq__"